<template>
  <div>
    <h2 class="text-center text-white">Contact Us</h2>
    <div class="special-bg">
      <div class="spacer" />
      <div id="row-spacer" />
      <div class="row container align-children-center">
          <div class="col-4 dark-bg d-pc text-white">
              <div class="p-3 row align-children-center">
                <div class="col-2">
                  <img class="maximum-height" src="../assets/icons/address.png" />
                </div>
                <div class="col-11"><p class="p-3 text-left">72 Kembla St Fyshwick 2609</p></div>
              </div>
              <div class="p-3 row align-children-center">
                <div class="col-2">
                  <img class="maximum-height" src="../assets/icons/phone.png" />
                </div>
                <div class="col-11"><p class="p-3 text-left">1300 727 320</p></div>
              </div>
          </div>
          <form class="col-8 white-bg">
              <label class="row p-1" for="name">Your Name</label>
              <input type="text" id="name" ref="name" name="name" placeholder="Enter Your Name" />
              <label class="row p-1" for="email">Your Email</label>
              <input  type="text" id="email" ref="email" name="email" placeholder="Enter Your Email Address" />
              <label class="row p-1" for="subject">Subject</label>
              <input type="text" id="subject" ref="subject" name="subject" placeholder="Enter A Subject" />
              <label class="row p-1" for="message">Your Message</label>
              <textarea id="message" name="message" ref="message" placeholder="Enter A Message" />
              <vue-recaptcha sitekey="6LeTX8YUAAAAAEJyiQ7Yk4brJTt3XaLbkMxLVLB5" :loadRecaptchaScript="true" v-on:verify="sendMail">
              <button :class="{'btn-sent': btnState}">Verify And Send</button>
              </vue-recaptcha>
          </form>
      </div>
    </div>
    <div class="text-center big-map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3254.4203687648765!2d149.22377881567672!3d-35.34521258027402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b164eee10a00557%3A0x9da4de4a289468e7!2sQueanbeyan%20Carpets!5e0!3m2!1sen!2sau!4v1574311042658!5m2!1sen!2sau"
                frameborder="0" style="margin-top:3em; border:0; width:100%; height:20rem" allowfullscreen></iframe>
    </div>
    <p class="container text-white d-m">
      Phone number: 1300 727 320
      <br />
      Address: 72 Kembla St Fyshwick 2609
    </p>
</div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'
import querystring from 'querystring'
export default {
  name: 'contact',
  components: { VueRecaptcha },
  data () {
    return {
      btnState: false
    }
  },
  methods: {
    sendMail () {
      this.btnState = true
      var messageContent = {
        'name': this.$refs.name.value,
        'email': this.$refs.email.value,
        'subject': this.$refs.subject.value,
        'message': this.$refs.message.value
      }
      var messageString = querystring.stringify(messageContent)
      console.log(messageString)
      axios.post('/mail.php', messageString).then(function (response) {
        alert('message sent')
      })
    }
  }
}
</script>
<style lang="postcss" scoped>
  .special-bg {
    background-image: url("../assets/backgrounds/car-sunset.jpg") !important;
  }
  .big-map {
    width: 101%;
    margin-left: -0.5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue